import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import Wrapper from "../wrapper/Wrapper";
import { Quantity } from "../cart/CartHelpers";
import { Counter } from "../menu/Counter";
import Carousel from '../carousel/Carousel';
import { Loading } from '../state/Loading';
import { RetailAbout } from "./RetailAbout";
import LoadScript from "react-load-script";
import { AddThis } from "../addthis/Addthis";
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { Container, Row, Col, Button, FormGroup, Tab, Tabs } from "react-bootstrap";
import ReactImageMagnify from 'react-image-magnify';
import { PowerReviewConfig } from "react-power-reviews";
import { FaExclamationTriangle } from "react-icons/fa";
import MetaTags from 'react-meta-tags';
import * as UTIL from "../../util";
import MediaQuery from "react-responsive";
import { ecommAdd, ecommEdit, ecommDetail } from "../../util";

var handlePrice = function handlePrice(listPrice, adjustedPrice) {
  if (listPrice === adjustedPrice) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, "$", listPrice.toFixed(2));
  } else {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strike", null, "$", listPrice.toFixed(2)), " $", adjustedPrice.toFixed(2));
  }
};

var handleDetailReturn = function handleDetailReturn(res) {
  var Images = res.Images;

  if (Array.isArray(Images)) {
    res.imgUrls = Images === null || Images === void 0 ? void 0 : Images.map(function (image) {
      return image.ImageUrl;
    });
  }

  if ((res === null || res === void 0 ? void 0 : res.Description) === null) {
    res.Attributes.Description = "";
  } else {
    res.Attributes.Description = res === null || res === void 0 ? void 0 : res.Description;
  }

  return res;
};

export var RetailDetailWrapper = function RetailDetailWrapper(props) {
  var _props$fields;

  var _props$recieveError = props.recieveError,
      recieveError = _props$recieveError === void 0 ? function (err) {
    return console.log(err, "RETAILDETAILERROR");
  } : _props$recieveError;

  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(props === null || props === void 0 ? void 0 : (_props$fields = props.fields) === null || _props$fields === void 0 ? void 0 : _props$fields.product),
      _useState4 = _slicedToArray(_useState3, 2),
      product = _useState4[0],
      setProduct = _useState4[1];

  useEffect(function () {
    var _props$fields2;

    var productId;

    try {
      productId = parseInt(window.location.href.substring(window.location.href.lastIndexOf('/') + 1));

      if (isNaN(productId)) {
        throw "err";
      }
    } catch (_unused) {
      var search = location.search.substring(1);
      var query = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}');
      productId = query.sku;
    }

    if (Boolean(props === null || props === void 0 ? void 0 : (_props$fields2 = props.fields) === null || _props$fields2 === void 0 ? void 0 : _props$fields2.product)) {
      var _props$fields3;

      var pascal = UTIL.toPascal(props === null || props === void 0 ? void 0 : (_props$fields3 = props.fields) === null || _props$fields3 === void 0 ? void 0 : _props$fields3.product);
      var formatted = handleDetailReturn(pascal);
      setProduct(formatted);
      setLoading(false);
      return;
    } else {
      UTIL.apiUtil.fetchGet("".concat(UTIL.apiUtil.API.retail.getDetail, "/").concat(productId)).then(function (res) {
        var formatted = handleDetailReturn(res);
        setProduct(formatted);
        setLoading(false);
      }).catch(function (err) {
        var error = {
          response: {
            data: {
              results: {
                code: "cb7502"
              }
            }
          }
        };
        recieveError(UTIL.buildError(error));
      });
      return;
    }
  }, []);
  return isLoading ? /*#__PURE__*/React.createElement(Loading, {
    isLoading: isLoading
  }) : /*#__PURE__*/React.createElement(RetailDetail, _extends({}, props, {
    product: product
  }));
};
export var RetailDetail = function RetailDetail(props) {
  var _props$product = props.product,
      product = _props$product === void 0 ? {} : _props$product,
      _props$layout = props.layout,
      layout = _props$layout === void 0 ? {
    padding: "small"
  } : _props$layout,
      _props$fields4 = props.fields,
      fields = _props$fields4 === void 0 ? {} : _props$fields4,
      _props$addToRecentlyV = props.addToRecentlyViewed,
      addToRecentlyViewed = _props$addToRecentlyV === void 0 ? function () {
    return console.log("ADDTORECENT");
  } : _props$addToRecentlyV,
      _props$postItem = props.postItem,
      postItem = _props$postItem === void 0 ? function (item) {
    return console.log(item, "POSTITEM");
  } : _props$postItem;
  var title = product.DisplayName,
      isExclusive = product.IsExclusive,
      ListPrice = product.ListPrice,
      description = product.Description,
      _product$Attributes = product.Attributes,
      attributes = _product$Attributes === void 0 ? {} : _product$Attributes,
      _product$Variants = product.Variants,
      Variants = _product$Variants === void 0 ? [] : _product$Variants,
      ProductId = product.ProductId,
      StockStatusNameLong = product.StockStatusNameLong,
      AdjustedPrice = product.AdjustedPrice,
      AvailableInventory = product.AvailableInventory,
      _product$MetaData = product.MetaData,
      MetaData = _product$MetaData === void 0 ? {} : _product$MetaData;
  var MetaTitle = MetaData.MetaTitle,
      MetaDescription = MetaData.MetaDescription,
      MetaKeywords = MetaData.MetaKeywords;
  var shippingInformation = fields.shippingInformation;

  var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      selectedSize = _useState6[0],
      setSize = _useState6[1];

  var _useState7 = useState(undefined),
      _useState8 = _slicedToArray(_useState7, 2),
      selectedColor = _useState8[0],
      setColor = _useState8[1];

  var _useState9 = useState(),
      _useState10 = _slicedToArray(_useState9, 2),
      sku = _useState10[0],
      setSku = _useState10[1];

  var _useState11 = useState(AvailableInventory === 0 ? 0 : 1),
      _useState12 = _slicedToArray(_useState11, 2),
      stateQuantity = _useState12[0],
      setQuantity = _useState12[1];

  var _useState13 = useState(AvailableInventory),
      _useState14 = _slicedToArray(_useState13, 2),
      stateAvailable = _useState14[0],
      setAvailable = _useState14[1];

  var _useState15 = useState(StockStatusNameLong),
      _useState16 = _slicedToArray(_useState15, 2),
      stockInfo = _useState16[0],
      setStockInfo = _useState16[1];

  var _useState17 = useState(0),
      _useState18 = _slicedToArray(_useState17, 2),
      currentSlide = _useState18[0],
      setCurrent = _useState18[1];

  var _useState19 = useState(0),
      _useState20 = _slicedToArray(_useState19, 2),
      cost = _useState20[0],
      setCost = _useState20[1];

  var _useState21 = useState(0),
      _useState22 = _slicedToArray(_useState21, 2),
      adjusted = _useState22[0],
      setAdjusted = _useState22[1];

  var _useState23 = useState(""),
      _useState24 = _slicedToArray(_useState23, 2),
      variantOptions = _useState24[0],
      setVariantOptions = _useState24[1];

  var _useState25 = useState(""),
      _useState26 = _slicedToArray(_useState25, 2),
      metaTitle = _useState26[0],
      setMetaTitle = _useState26[1];

  var _useState27 = useState([]),
      _useState28 = _slicedToArray(_useState27, 2),
      imgUrls = _useState28[0],
      setImgUrls = _useState28[1];

  var sizeOptions = Variants.filter(function (variant) {
    return Boolean(variant.VariantProperties.Size && !variant.VariantProperties.Color);
  }).map(function (variant) {
    return {
      label: variant.VariantProperties.Size,
      value: variant.VariantProperties.Size
    };
  });
  var colorOptions = Variants.filter(function (variant) {
    return Boolean(variant.VariantProperties.Color && !variant.VariantProperties.Size);
  }).map(function (variant) {
    var _variant$Images$;

    return {
      label: variant.VariantProperties.Color,
      value: variant.VariantProperties.Color,
      swatch: Array.isArray(variant.Images) ? (_variant$Images$ = variant.Images[0]) === null || _variant$Images$ === void 0 ? void 0 : _variant$Images$.SwatchUrl : ""
    };
  });

  var groupBy = function groupBy(objectArray, property) {
    return objectArray.reduce(function (acc, obj) {
      var key = obj[property];

      if (!acc[key]) {
        acc[key] = [];
      }

      acc[key].push(obj);
      return acc;
    }, {});
  };

  var bothOptions = groupBy(Variants.filter(function (variant) {
    return Boolean(variant.VariantProperties.Size && variant.VariantProperties.Color);
  }).map(function (variant) {
    var _variant$Images$2;

    return {
      size: variant.VariantProperties.Size,
      color: {
        label: variant.VariantProperties.Color,
        value: variant.VariantProperties.Color,
        swatch: Array.isArray(variant.Images) ? (_variant$Images$2 = variant.Images[0]) === null || _variant$Images$2 === void 0 ? void 0 : _variant$Images$2.SwatchUrl : ""
      },
      fullVariant: variant
    };
  }), "size");
  useEffect(function () {
    //Added due to rendering issue
    setTimeout(function () {
      return setMetaTitle(MetaTitle);
    }, 500);
  }, []);
  useEffect(function () {
    if (ProductId) {
      var _product$imgUrls;

      setSku(ProductId);
      setImgUrls(product === null || product === void 0 ? void 0 : product.imgUrls);
      setCost(ListPrice);
      setAdjusted(AdjustedPrice);
      addToRecentlyViewed({
        href: window.location.href,
        imgUrl: (product === null || product === void 0 ? void 0 : (_product$imgUrls = product.imgUrls) === null || _product$imgUrls === void 0 ? void 0 : _product$imgUrls.length) > 0 ? product.imgUrls[0] : "",
        imgAlt: title
      });

      var reviewConfig = _objectSpread({}, UTIL.powerReviewConfig);

      reviewConfig.components = {
        ReviewDisplay: "detailReviewDisplay",
        categorySnippets: "powerReviews-sku"
      };
      reviewConfig.pageId = ProductId;
      reviewConfig.categorySnippets = {
        id: "powerReviews-sku",
        snippets: [ProductId]
      };
      reviewConfig.wrapperUrl = "/write-a-review?page_id=".concat(ProductId);
      PowerReviewConfig(reviewConfig);
    }

    ecommDetail({
      name: title,
      id: (product === null || product === void 0 ? void 0 : product.ProductChainId) || ProductId,
      price: ListPrice,
      detailLink: (product === null || product === void 0 ? void 0 : product.detailLink) || "",
      catalog: (product === null || product === void 0 ? void 0 : product.CatalogName) || ""
    });
  }, [ProductId]);
  useEffect(function () {
    if (typeof selectedSize === "number" && sizeOptions.length) {
      getVariant(selectedSize);
    }

    if (typeof selectedColor === "number" && colorOptions.length) {
      getVariant(selectedColor);
    }
  }, [selectedSize, selectedColor]);

  var getVariant = function getVariant(index) {
    return updateForVariant(Variants[index]);
  };

  var updateForVariant = function updateForVariant(variantObj) {
    var _variantObj$Images, _variantObj$Images2;

    setSku(variantObj.ProductVariantId);
    setCost(variantObj.ListPrice);
    setAdjusted(variantObj.AdjustedPrice);
    setImgUrls((variantObj === null || variantObj === void 0 ? void 0 : (_variantObj$Images = variantObj.Images) === null || _variantObj$Images === void 0 ? void 0 : _variantObj$Images.length) ? variantObj === null || variantObj === void 0 ? void 0 : (_variantObj$Images2 = variantObj.Images) === null || _variantObj$Images2 === void 0 ? void 0 : _variantObj$Images2.map(function (image) {
      return image.ImageUrl;
    }) : product.imgUrls);
    setVariantOptions(Object.values(variantObj.VariantProperties).filter(Boolean).join(", "));
    setStockInfo(variantObj.StockStatusNameLong);
    setAvailable(variantObj.AvailableInventory);
    setQuantity(variantObj.AvailableInventory === 0 ? 0 : 1);
  };

  var handleSubmit = function handleSubmit() {
    var variantSku = ProductId === sku ? "" : sku;
    var formInfo = {
      "options": [],
      "variantOptions": variantOptions,
      "StoreProductId": null,
      "ProductChainId": ProductId,
      "VariantId": variantSku,
      "Quantity": stateQuantity,
      "imageUrl": imgUrls[0],
      "total": adjusted * stateQuantity || cost * stateQuantity,
      "displayName": title,
      "catalogName": "shop"
    };
    ecommAdd({
      name: title,
      id: (product === null || product === void 0 ? void 0 : product.ProductChainId) || ProductId,
      price: ListPrice,
      detailLink: (product === null || product === void 0 ? void 0 : product.detailLink) || "",
      catalog: (product === null || product === void 0 ? void 0 : product.CatalogName) || ""
    });
    return postItem(formInfo);
  };

  var handleScriptLoad = function handleScriptLoad() {
    window.addthis.init(); // window.addthis.toolbox('.addthis_toolbox')
  };

  var isDisabled = !(stateQuantity > 0) || !(typeof selectedSize === "number" && sizeOptions.length || typeof selectedColor === "number" || Variants.length === 0);
  var bothOptionsExist = Boolean(Object.keys(bothOptions).length);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-retail-detail"
  }, /*#__PURE__*/React.createElement(MetaTags, null, Boolean(metaTitle) && /*#__PURE__*/React.createElement("title", null, metaTitle), Boolean(MetaDescription) && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: MetaDescription
  }), Boolean(MetaKeywords) && /*#__PURE__*/React.createElement("meta", {
    property: "keywords",
    content: MetaKeywords
  })), /*#__PURE__*/React.createElement(Wrapper, {
    layout: layout
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6",
    md: "12"
  }, /*#__PURE__*/React.createElement(Carousel, {
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false,
    dotsClass: "",
    type: "retail",
    beforeChange: function beforeChange(prev, next) {
      setCurrent(next);
    },
    afterChange: function afterChange(index) {
      return setCurrent(index);
    },
    appendDots: function appendDots(dots) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(MediaQuery, {
        minWidth: 991
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "row img-dots"
      }, dots === null || dots === void 0 ? void 0 : dots.map(function (item, index) {
        return /*#__PURE__*/React.createElement(Col, {
          lg: "3",
          key: index,
          className: currentSlide === index ? "is-active " : ""
        }, item.props.children);
      })))), /*#__PURE__*/React.createElement(MediaQuery, {
        maxWidth: 990
      }, /*#__PURE__*/React.createElement("ul", {
        className: "slick-dots"
      }, dots.map(function (item, index) {
        return /*#__PURE__*/React.createElement("li", {
          className: currentSlide === index ? "slick-active " : ""
        }, /*#__PURE__*/React.createElement("button", null, index));
      }))));
    },
    customPaging: function customPaging(index) {
      return /*#__PURE__*/React.createElement("img", {
        src: imgUrls[index]
      });
    },
    responsive: [{
      breakpoint: 540,
      // settings: {
      //   slidesToShow: 2,
      //   arrows: false,
      //   dots: true,
      //   touchMove: true,
      dotsClass: "slick-dots" //   beforeChange: undefined,
      //   afterChange: undefined,
      //   appendDots: undefined,
      //   customPaging: undefined
      // }

    }]
  }, imgUrls.map(function (src, index) {
    return /*#__PURE__*/React.createElement(ReactImageMagnify, {
      smallImage: {
        alt: 'placeholder',
        isFluidWidth: true,
        src: src
      },
      largeImage: {
        src: src,
        width: 1280,
        height: 1248
      },
      enlargedImageContainerStyle: {
        zIndex: 3
      },
      enlargedImagePosition: 'over',
      key: index
    });
  }))), /*#__PURE__*/React.createElement(Col, {
    lg: "6",
    md: "12"
  }, isExclusive && /*#__PURE__*/React.createElement("span", {
    className: "cb-card__food-avail cb-exclusive"
  }, "EXCLUSIVE"), Boolean(isExclusive && stockInfo) && /*#__PURE__*/React.createElement("span", {
    className: "cb-card__food-avail cb-exclusive"
  }, ", "), stockInfo && /*#__PURE__*/React.createElement("span", {
    className: "cb-card__food-avail cb-exclusive"
  }, stockInfo), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(RichText, {
    field: {
      value: title
    },
    tag: "h1",
    className: "mwidth-300 cb-retail-detail__title"
  }), /*#__PURE__*/React.createElement("p", null, "SKU ", sku), /*#__PURE__*/React.createElement("div", {
    id: "powerReviews-sku-".concat(ProductId)
  }), /*#__PURE__*/React.createElement("span", {
    className: "cb-retail-detail__title cb-retail-detail__cost"
  }, handlePrice(cost, adjusted)), !bothOptionsExist && /*#__PURE__*/React.createElement(Options, {
    selected: selectedSize,
    setSelected: setSize,
    options: sizeOptions,
    label: "Size"
  }), !bothOptionsExist && /*#__PURE__*/React.createElement(Options, {
    selected: selectedColor,
    setSelected: setColor,
    options: colorOptions,
    label: "Color"
  }), bothOptionsExist && /*#__PURE__*/React.createElement(BothOptions, {
    size: selectedSize,
    setSize: setSize,
    color: selectedColor,
    setColor: setColor,
    options: bothOptions,
    sku: sku,
    updateForVariant: updateForVariant
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-retail-detail__counter-wrapper"
  }, /*#__PURE__*/React.createElement(Counter, {
    disabled: isDisabled,
    setValue: setQuantity,
    userInput: false,
    counterValues: {
      min: 0,
      max: stateAvailable
    },
    value: stateQuantity,
    className: "cb-menu-counter"
  }), stateAvailable - 5 <= stateQuantity && stateAvailable > 0 && /*#__PURE__*/React.createElement("div", {
    className: "cb-menu-counter mt-16"
  }, /*#__PURE__*/React.createElement(FaExclamationTriangle, null), " Only ", stateAvailable, " left"), stateAvailable === 0 && /*#__PURE__*/React.createElement("div", {
    className: "cb-menu-counter mt-16"
  }, /*#__PURE__*/React.createElement(FaExclamationTriangle, null), " ", stockInfo))), /*#__PURE__*/React.createElement(Col, {
    lg: "2"
  })), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    disabled: isDisabled,
    onClick: handleSubmit
  }, "Add To Cart"), /*#__PURE__*/React.createElement(AddThis, null))))), /*#__PURE__*/React.createElement(RetailAbout, {
    attributes: attributes,
    shippingInformation: shippingInformation
  }), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "detailReviewDisplay"
  })))))), /*#__PURE__*/React.createElement(LoadScript, {
    url: "//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5eb47c51fed4d62a",
    onLoad: handleScriptLoad
  }));
};

var Options = function Options(props) {
  var _options$selected;

  var label = props.label,
      selected = props.selected,
      _props$setSelected = props.setSelected,
      setSelected = _props$setSelected === void 0 ? function () {
    return "";
  } : _props$setSelected,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options;
  var selectedObj = options[selected];
  var value = typeof selected === "number" ? (_options$selected = options[selected]) === null || _options$selected === void 0 ? void 0 : _options$selected.value : "";
  return Boolean(options.length) && /*#__PURE__*/React.createElement("div", {
    className: "cb-retail__size-container"
  }, label && /*#__PURE__*/React.createElement("p", null, label, ": ", typeof selected === "number" ? selectedObj === null || selectedObj === void 0 ? void 0 : selectedObj.label : ""), /*#__PURE__*/React.createElement("ul", null, options.map(function () {
    var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var index = arguments.length > 1 ? arguments[1] : undefined;
    var swatchExists = Boolean(option.swatch);
    return /*#__PURE__*/React.createElement("li", {
      className: "cb-retail__size-option ".concat(swatchExists ? "cb-retail__size-option--image" : "")
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      checked: value === option.value
    }), /*#__PURE__*/React.createElement("label", {
      onClick: function onClick() {
        return setSelected(index);
      }
    }, swatchExists ? /*#__PURE__*/React.createElement("img", {
      src: option.swatch
    }) : option.label));
  })));
};

var BothOptions = function BothOptions(props) {
  var size = props.size,
      setSize = props.setSize,
      color = props.color,
      setColor = props.setColor,
      options = props.options,
      updateForVariant = props.updateForVariant,
      sku = props.sku;
  var entries = Object.entries(options);
  var sizes = entries.map(function (el) {
    return {
      label: el[0],
      value: el[0]
    };
  });
  var colorOptions = typeof size === "number" ? entries[size][1] : [];
  var colors = colorOptions.map(function (a) {
    return a.color;
  });
  useEffect(function () {
    var colorExists = colorOptions[color];

    if (colorExists) {
      var _colorOptions$color;

      var fullVariant = (_colorOptions$color = colorOptions[color]) === null || _colorOptions$color === void 0 ? void 0 : _colorOptions$color.fullVariant;

      if (typeof color === "number" && sku !== (fullVariant === null || fullVariant === void 0 ? void 0 : fullVariant.ProductVariantId)) {
        updateForVariant(colorOptions[color].fullVariant);
      }
    }
  }, [color, colorOptions]);
  useEffect(function () {
    setColor(undefined);
  }, [size]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Options, {
    selected: size,
    setSelected: setSize,
    options: sizes,
    label: "Size"
  }), /*#__PURE__*/React.createElement(Options, {
    selected: color,
    setSelected: setColor,
    options: colors,
    label: "Color"
  }));
};